// extracted by mini-css-extract-plugin
export default {"container":"rL-z","disabled":"sL-z","termsCheckbox":"tL-z","signUpButton":"uL-z","enrollingSpinner":"vL-z","learnMoreButton":"wL-z","buttonRow":"xL-z"};